import React from 'react';
import PageHeader from './global-components/page-header';
import Cat from './section-components/cat-sports';

const CatSports = () => {
    return <div>
        <PageHeader headertitle="Sports"  />
        <Cat />
    </div>
}

export default CatSports

